import _request from '@/utils/request.js'
var _tax = {
  // - 查询剩余可开票金额接口(前端页面计算用)
  getSurplusInvoiceAmount (info, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceInfo/getSurplusInvoiceAmount"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  getContractCompanyInvoiceType (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceInfo/getContractCompanyInvoiceType"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  selectEnum (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/common/selectEnum"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //查询税收
  taxCategoryList (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/taxCategory/getList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },

  //数据导入
  importData (file, resolve, reject) {
    _request.upload({
      url: _request.getFinanceUrl("/api/taxCategory/importData"),
      file: file,
      success: resolve,
      error: reject
    })
  },
  //上传附件
  uploadFile (file,invoiceMaxAmount, resolve, reject) {
    _request.upload({
      url: _request.getFinanceUrl("/api/file/uploadFile?invoiceMaxAmount="+invoiceMaxAmount),
      file:file,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //上传文件(批量开票)
  batchOpenInvoiceUpload (file, resolve, reject) {
    _request.upload({
      url: _request.getFinanceUrl("/api/file/batchOpenInvoiceUpload"),
      file:file,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //批量开票
  updateBatchOpenInvoice (info, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceInfo/updateBatchOpenInvoice"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //税收详情
  taxCategoryGetDetail (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/taxCategory/getDetail"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //开票列表
  taxGetListPage (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/manage/getListPage"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //开票详情
  invoiceApplyGetDetail (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/getDetail"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //开票详情提交
  invoiceApplyGetDetailSubmit (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/submit"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //获取客户名称
  queryCustomerByUser (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/stored/queryCustomerByUser"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //查看合约公司列表
  getContractCompany (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/company/getContractCompanyListForSelect"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //查询可开票订单列表接口
  getInvoiceApplyOrderList (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/getOrderList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //客户发票信息
  getCustomerInvoice (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/customerManage/customerInvoice/getTitleList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //客户发票信息
  getInvoiceContentList (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/company/getInvoiceContentList"),
      data: query,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //确认开票
  createOrUpdate (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/createOrUpdate"),
      data: query,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //复制
  duplicate (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/duplicate"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //待开票
  toBeInvoiced (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/toBeInvoiced/getListPage"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //发票信息列表查询
  getListInfoPage (query, resolve, reject) {
     _request.api({
      url: _request.getFinanceUrl("/api/invoiceInfo/getListPage"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  getInfoDetail (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceInfo/getDetail"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //修改发票号码
  updateInvoiceCode (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceInfo/updateInvoiceCode"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //单张开票
  updateSolaOpenInvoice (info, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceInfo/updateSolaOpenInvoice"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //待开票弹窗列表
  getInvoiceBaseList (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/getInvoiceBaseList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  confirmInvoice (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/confirmInvoice"),
      data: query,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //导出
  exportInvoiceData (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/exportInvoiceData"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //作废发票
  cancelInvoiceData (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/cancel/submit"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //发票内容明细
  getContentDetail (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/getContentDetail"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //修改记录
  getCodeModifyList (query, resolve, reject) {
    _request.api({
      url: _request.getFinanceUrl("/api/invoiceApply/getCodeModifyList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //批量导出
  invoiceInfoExport (query) {
    _request.download(
      _request.getFinanceUrl(`/invoiceInfoExport/getInvoiceInfoBatchExportExcel?applyUserName=${query.applyUserName}&companyId=${query.companyId}&endTime=${query.endTime}&invoiceApplyCode=${query.invoiceApplyCode}&invoiceState=${query.invoiceState}&invoiceTitle=${query.invoiceTitle}&invoiceType=${query.invoiceType}&pageIndex=${query.pageIndex}&pageSize=${query.pageSize}&startTime=${query.startTime}&total=${query.total}`),

    )
  },
  getUnitPrice(query, resolve, reject){
    _request.api({
        url: _request.getFinanceUrl("/api/invoiceInfo/getUnitPrice"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
  //校验手动输入的发票内容
  checkSpecialInvoiceContent (query, resolve, reject) {
        _request.api({
          url: _request.getFinanceUrl("/api/invoice/special/checkSpecialInvoiceContent"),
          data: query,
          method: 'post',
          success: resolve,
          error: reject
        })
    },
    //校验文件导入
    checkBatchFinance (file, resolve, reject) {
        _request.upload({
          url: _request.getFinanceUrl("/api/invoice/special/checkBatchFinance"),
          file: file,
          method: 'post',
          success: resolve,
          error: reject
        })
    },
}

export default _tax